import { useState, useEffect } from 'react';
import { useStore } from '@/store';
import { Button } from '@/components/ui/button';
import { X } from 'lucide-react';

export function NotificationPopup() {
  const { subscribeToNotifications, notificationsEnabled } = useStore();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const hasPrompted = localStorage.getItem('notificationsPrompted');
    if (!hasPrompted && !notificationsEnabled) {
      setIsVisible(true);
      localStorage.setItem('notificationsPrompted', 'true');
    }
  }, [notificationsEnabled]);

  const handleSubscribe = async () => {
    try {
      await subscribeToNotifications();
      setIsVisible(false);
    } catch (error) {
      console.warn('Failed to enable notifications:', error);
      setIsVisible(false);
    }
  };

  const handleClose = () => {
    setIsVisible(false);
  };

  if (!isVisible) return null;

  return (
    <div className="fixed inset-0 flex items-center justify-center z-50">
      <div className="fixed inset-0 bg-black/50" onClick={handleClose} />
      <div className="relative bg-white dark:bg-gray-800 p-6 rounded-lg shadow-xl max-w-sm w-full mx-4">
        <div className="flex justify-between items-center mb-4">
          <h2 className="text-lg font-medium text-gray-900 dark:text-white">Enable Notifications</h2>
          <button
            onClick={handleClose}
            className="text-gray-400 hover:text-gray-500 dark:hover:text-gray-300"
          >
            <X className="h-5 w-5" />
          </button>
        </div>
        <p className="text-gray-600 dark:text-gray-400 mb-6">
          Receive notifications about orders and promotions.
        </p>
        <Button onClick={handleSubscribe} className="w-full">
          Enable
        </Button>
      </div>
    </div>
  );
}